var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCadeiraIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "sw-js-blob-svg",
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "sw-gradient",
    x1: 0,
    x2: 1,
    y1: 1,
    y2: 0
  }, /*#__PURE__*/React.createElement("stop", {
    id: "stop1",
    stopColor: "rgba(248, 117, 55, 1)",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop2",
    stopColor: "rgba(251, 168, 31, 1)",
    offset: "100%"
  })))), /*#__PURE__*/React.createElement("path", {
    fill: "url(#sw-gradient)",
    d: "M18.6,-21.9C26.3,-15.7,36.3,-11.9,37.4,-6.5C38.5,-1,30.8,6.2,24.8,12.1C18.7,18.1,14.4,22.8,7.8,28C1.2,33.3,-7.5,39,-15.9,38.3C-24.3,37.6,-32.2,30.4,-36.9,21.6C-41.5,12.9,-42.8,2.5,-41.3,-7.5C-39.8,-17.5,-35.4,-27.3,-28.1,-33.5C-20.7,-39.7,-10.4,-42.4,-2.5,-39.5C5.5,-36.6,10.9,-28,18.6,-21.9Z",
    width: "100%",
    height: "100%",
    transform: "translate(50 50)",
    strokeWidth: 0,
    style: {
      transition: "0.3s"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCadeiraIcon);
export default __webpack_public_path__ + "static/media/cadeira-icon.48a5dde0324031317c2adc7d1df56c30.svg";
export { ForwardRef as ReactComponent };